let suppressionDepth = 0;

// True while a programmatic auto-focus is applying focus and controls must NOT
// open their overlay as a side effect of receiving focus (e.g. the reference
// multi-select quicksearch popping open when the form auto-focuses its first
// field). Controls that open on focus read this and skip the open.
export const isOpenOnFocusSuppressed = (): boolean => suppressionDepth > 0;

// Runs `focus` with open-on-focus suppression active for the synchronous focus
// event it triggers. Reentrant via a depth counter so nested calls are safe.
export const withOpenOnFocusSuppressed = (focus: () => void): void => {
  suppressionDepth += 1;
  try {
    focus();
  } finally {
    suppressionDepth -= 1;
  }
};
